<template>
	<div class="add_dev">
		<div class="add_dev_alert">
			<div class="close_btn" @click="hideBindClick"></div>
			<div class="add_title">绑定设备</div>
			<div class="right_item">
				<div class="right_item_title">方法 1</div>
				<div class="right_item_name">快速绑定</div>
				<div class="right_item_desc">通过NAS打开节点小宝即可绑定</div>
				<div class="right_item_btn" @click="showHelp">安装指南</div>
			</div>
			<div class="right_item right_item_02">
				<div class="right_item_title">方法 2</div>
				<div class="right_item_name">绑定码绑定</div>
				<div class="right_item_bottom">
					<div class="right_item_input">
						<div class="input_tips">{{ inputTips }}</div>
						<input
							type="number"
							v-model="activecode"
							@focus="onInputFocus"
							@blur="onInputBlur"
							v-on:input="inputFun()"
							@keydown.enter="bindDeviceClick"
						/>
					</div>
					<div class="right_item_bind" @click="bindDeviceClick">
						绑定
					</div>
				</div>
			</div>
		</div>
		<InstallHelp v-if="isShowHelp" @onCancelClick="hideHelp"></InstallHelp>
	</div>
</template>

<script>
import InstallHelp from "@/components/Node/InstallHelp.vue";
export default {
	data: function () {
		return {
			activecode: "",
			isShowHelp: false,
			inputTips: "输入绑定码",
		};
	},
	components: {
		InstallHelp,
	},
	methods: {
		onInputFocus: function () {
			this.inputTips = "";
		},
		onInputBlur: function () {
			if (!this.activecode) {
				this.inputTips = "输入绑定码";
			}
		},
		inputFun: function () {
			let _that = this;
			if (_that.activecode.length > 6) {
				_that.activecode = _that.activecode.slice(0, 6);
			}
		},
		showHelp: function () {
			this.isShowHelp = true;
		},
		hideHelp: function () {
			this.isShowHelp = false;
		},
		bindDeviceClick: function () {
			let _that = this;
			if (!_that.activecode) {
				_that.$store.state.toast = "请输入绑定码";
				return;
			} else if (_that.activecode.length < 6) {
				_that.$store.state.toast = "绑定码无效";
				return;
			}
			_that.$emit("bindDeviceClick", _that.activecode);
			_that.$emit("showOrHideBindClick", false);
		},
		hideBindClick: function () {
			let _that = this;
			_that.$emit("showOrHideBindClick", false);
		},
	},
};
</script>

<style lang="less" scoped>
.add_dev {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: 9;
	background-color: rgba(82, 82, 82, 0.36);
	.add_dev_alert {
		width: 410px;
		height: 360px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -205px;
		margin-top: -180px;
		background-color: #ffffff;
		border-radius: 5px;
		padding-top: 1px;

		.close_btn {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 10px;
			top: 10px;
			background-image: url(../../assets/common/close4.svg);
			background-size: 100% 100%;
			cursor: pointer;
			z-index: 2;
		}
		.close_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}

		.add_title {
			font-size: 20px;
			font-weight: bolder;
			color: #333333;
			text-align: center;
			margin-top: 30px;
			margin-bottom: 20px;
		}

		.right_item {
			width: 360px;
			height: 108px;
			background-color: rgba(227, 233, 241, 1);
			background-image: url(../../assets/node/nobind/right_item_bg.png);
			background-size: 100% 100%;
			text-align: left;
			position: relative;
			border-radius: 6px;
			overflow: hidden;
			margin: 0 auto;
			.right_item_title {
				width: 92px;
				height: 29px;
				line-height: 28px;
				background-image: url(../../assets/node/nobind/item_banner.png);
				background-size: 104px 35px;
				background-position: center center;
				color: rgba(109, 62, 18, 1);
				font-size: 12px;
				font-weight: bolder;
				text-align: left;
				box-sizing: border-box;
				padding-left: 20px;
				margin-top: -1px;
			}
			.right_item_name {
				margin-left: 36px;
				color: rgba(41, 64, 119, 1);
				font-size: 15px;
				font-weight: bolder;
				height: 20px;
				line-height: 20px;
				margin-top: 10px;
			}
			.right_item_desc {
				margin-left: 36px;
				color: rgba(118, 126, 152, 1);
				font-size: 12px;
				margin-top: 10px;
				height: 20px;
				line-height: 20px;
			}
			.right_item_btn {
				background-color: rgba(31, 93, 227, 1);
				width: 106px;
				height: 36px;
				line-height: 36px;
				text-align: center;
				color: #ffffff;
				border-radius: 18px;
				font-size: 14px;
				position: absolute;
				right: 30px;
				bottom: 20px;
			}
			.right_item_btn:hover {
				cursor: pointer;
				opacity: 0.9;
			}
		}
		.right_item_02 {
			height: 123px;
			margin-top: 10px;
			.right_item_bottom {
				text-align: left;
				margin-left: 36px;
				margin-top: 10px;
				.right_item_input {
					display: inline-block;
					vertical-align: top;
					width: 168px;
					height: 36px;
					line-height: 36px;
					background-color: RGBA(240, 242, 244, 1);
					border: 1px solid rgba(227, 233, 241, 1);
					border-radius: 18px;
					margin-right: 19px;
					position: relative;
					.input_tips {
						width: 128px;
						height: 36px;
						line-height: 36px;
						position: absolute;
						left: 20px;
						top: 0px;
						text-align: center;
						font-size: 14px;
						color: rgba(102, 102, 102, 1);
					}
					input {
						width: 128px;
						height: 36px;
						line-height: 36px;
						// margin-left: 20px;
						color: #666666;
						font-size: 20px;
						font-weight: bolder;
						background-color: transparent;
						position: absolute;
						left: 20px;
						top: 0px;
						letter-spacing: 10px;
						text-align: left;
					}
					//谷歌
					input::-webkit-outer-spin-button,
					input::-webkit-inner-spin-button {
						-webkit-appearance: none;
					}

					//火狐
					input[type="number"] {
						-moz-appearance: textfield;
					}
				}
				.right_item_bind {
					display: inline-block;
					vertical-align: top;
					background-color: rgba(31, 93, 227, 1);
					width: 106px;
					height: 36px;
					line-height: 36px;
					text-align: center;
					color: #ffffff;
					border-radius: 18px;
					font-size: 14px;
				}
				.right_item_bind:hover {
					cursor: pointer;
					opacity: 0.9;
				}
			}
		}
	}
}
</style>